/* Club EarlyBird Javvy-pattern storefront (ported from Dustin's artifact, assets/js/pdp.js).
   Prototype shortcuts replaced with real store behaviour:
   - prices, plans and variant ids come from Liquid (data-config on .buy), never hardcoded
   - Add to Cart posts /cart/add.js with one line per flavor and its selling_plan, then opens the theme cart drawer
   - quick add uses the real variant + plan */
(function () {
  'use strict';

  var money = function (cents) { return '$' + (Math.round(cents) / 100).toFixed(2); };
  var pct = function (part, whole) { return whole > 0 ? Math.round((1 - part / whole) * 100) : 0; };

  /* Theme cart drawer (same sequence as openCartDrawer() in ceb-cro.js). Falls back to /cart. */
  async function openCartDrawer() {
    var D = window.Drawer;
    if (D && typeof D.getCart === 'function' && typeof D.buildCart === 'function' && document.querySelector('.cart-drawer')) {
      try {
        var cart = await D.getCart();
        document.body.classList.add('cart-drawer-open', 'cart-open');
        await D.buildCart(cart);
        refreshCount(cart);
        return 'drawer';
      } catch (e) { console.error('[CEB Javvy] Cart drawer failed, opening cart page', e); }
    }
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
    (window.__cebjvNavigate || function (u) { window.location.assign(u); })(url);
    return 'fallback';
  }

  function refreshCount(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n === null) return;
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n ? String(n) : '';
      el.classList.toggle('on', n > 0);
    });
  }

  /* Keep the header bag count in sync with the real cart (drawer edits, removals, other apps). */
  var nativeFetch = window.fetch.bind(window);
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var syncTimer = null;
  function syncCount() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(refreshCount).catch(function () {});
    }, 250);
  }
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(u)) p.then(syncCount, syncCount);
    } catch (e) {}
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (CART_RE.test(String(u))) this.addEventListener('loadend', syncCount); } catch (e) {}
    return xhrOpen.apply(this, arguments);
  };
  window.addEventListener('pageshow', syncCount);

  async function addItems(items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    var body = await r.json().catch(function () { return {}; });
    if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart');
    return body;
  }

  window.CEBJV = { openCartDrawer: openCartDrawer, addItems: addItems, money: money, pct: pct };

  /* ---------- Build-your-bundle buy box ----------
     Config (data-config, written by Liquid from real store data):
       rows[key] = { variant, oneVariant, available, oneAvailable, one, compare, tiers[4]: {plan, price, recurring}|null, p2?, p3? }
     Tier N plan is chosen from the number of units that can subscribe (a flavor with no plan, e.g. a
     one-time-only launch flavor, is added one-time and does not move the subscription tier). */
  function initBuy(buy) {
    var C = JSON.parse(buy.dataset.config);
    var rows = [].slice.call(buy.querySelectorAll('[data-row]'));
    var tiers = [].slice.call(buy.querySelectorAll('[data-tier]'));
    var fill = buy.querySelector('[data-tier-fill]');
    var subOpt = buy.querySelector('[data-plan="sub"]');
    var oneOpt = buy.querySelector('[data-plan="one"]');
    var subTab = buy.querySelector('[data-opt-tab]');
    var subLine = buy.querySelector('[data-sub-line]');
    var subPrice = buy.querySelector('[data-sub-price]');
    var subStrike = buy.querySelector('[data-sub-strike]');
    var onePrice = buy.querySelector('[data-one-price]');
    var future = buy.querySelector('[data-future]');
    var renew = buy.querySelector('[data-renew]');
    var kitNote = buy.querySelector('[data-kit-note]');
    var ctaNote = buy.querySelector('[data-cta-note]');
    var cta = buy.querySelector('[data-cta]');
    var status = buy.querySelector('[data-status]');
    var div = Number(C.div) || 1;
    var suffix = C.suffix || '/ea';
    var plan = C.hasSub ? 'sub' : 'one';
    var busy = false;
    if (!C.hasSub) buy.dataset.noSub = '1';

    var R = function (key) { return C.rows[key]; };
    var qty = function (r) { return Number(r.dataset.qty || 0); };
    var total = function () { return rows.reduce(function (s, r) { return s + qty(r); }, 0); };
    var canSub = function (row) { return row.tiers.some(function (t) { return t; }); };
    var subUnits = function () { return rows.reduce(function (s, r) { return s + (canSub(R(r.dataset.row)) ? qty(r) : 0); }, 0); };
    var tierIndex = function (n) { return n === 0 ? -1 : Math.min(n, 4) - 1; };
    var packFor = function (row, size) {
      if (size === 2 && row.p2) return { o: row.p2, size: 2 };
      if (size >= 3 && row.p3) return { o: row.p3, size: 3 };
      return { o: row, size: 1 };
    };
    /* One-time tier price: rows flagged oneOff (Javvy tubs) get the store's automatic one-time discount (C.oneOff, cents per unit by tier),
       counted on the units that go in one-time. */
    var oneUnits = function () {
      return rows.reduce(function (s, r) {
        var row = R(r.dataset.row);
        if (!row.oneOff) return s;
        return s + (plan !== 'sub' || !canSub(row) || !row.available ? qty(r) : 0);
      }, 0);
    };
    var oneEach = function (o, t) {
      var off = o.oneOff && C.oneOff ? Number(C.oneOff[Math.max(t, 0)] || 0) : 0;
      return Math.max(o.one - off, 0);
    };
    var giftEligible = function () {
      if (plan !== 'sub') return false;
      var ns = subUnits(); var t = tierIndex(ns);
      return t >= 0 && !!C.giftTiers[t] && ns >= C.giftMin && (C.gifts || []).length > 0;
    };

    /* Split a row's quantity into pack variants (largest first), then price each piece. */
    function lines() {
      var tp = Math.max(tierIndex(subUnits()), 0);
      var to = tierIndex(oneUnits());
      var out = [];
      rows.forEach(function (r) {
        var q = qty(r); if (!q) return;
        var row = R(r.dataset.row);
        var pieces = [];
        while (q > 0) {
          var size = q >= 3 && row.p3 ? 3 : q >= 2 && row.p2 ? 2 : 1;
          pieces.push(size === 1 ? row : size === 2 ? row.p2 : row.p3);
          q -= size;
        }
        pieces.forEach(function (o) {
          var t = plan === 'sub' ? o.tiers[tp] : null;
          var line = t && o.available
            ? { id: o.variant, quantity: 1, selling_plan: t.plan, price: t.price, was: Math.max(o.one, o.compare || 0), sub: true }
            : { id: o.oneVariant, quantity: 1, price: oneEach(o, to), was: Math.max(o.one, o.compare || 0), sub: false };
          var same = out.find(function (l) { return l.id === line.id && l.selling_plan === line.selling_plan; });
          if (same) same.quantity += 1; else out.push(line);
        });
      });
      return out;
    }

    function lineItems() {
      var ls = lines();
      var items = ls.map(function (l) {
        var it = { id: l.id, quantity: l.quantity };
        if (l.selling_plan) it.selling_plan = l.selling_plan;
        return it;
      });
      if (giftEligible()) {
        var bundleId = C.bundle && subUnits() >= 2 ? String(Date.now()) : null;
        if (bundleId) {
          items.forEach(function (it, i) {
            if (!ls[i].sub) return;
            it.properties = { 'Bundle ID': bundleId, Bundle: C.bundle };
          });
        }
        C.gifts.forEach(function (g) {
          var it = { id: g.id, quantity: g.quantity || 1 };
          if (bundleId) it.properties = { 'Bundle ID': bundleId };
          items.unshift(it);
        });
      }
      return items;
    }

    function render() {
      var n = total();
      var t = tierIndex(plan === 'sub' ? subUnits() : n); // one-time-only flavors never move the S&S tier tracker
      var tp = Math.max(tierIndex(plan === 'sub' ? subUnits() : n), 0);
      var ref = R(C.ref) || {};
      var refPlan = (ref.tiers || [])[tp];
      var eaPct = !!buy.querySelector('[data-ea-pct]'); // MC track shows savings % instead of $/ea

      tiers.forEach(function (el, i) {
        el.classList.toggle('on', i <= t);
        el.classList.toggle('current', i === t);
        var ea = el.querySelector('[data-ea]');
        if (!ea || !ref.tiers) return;
        var pk = packFor(ref, i + 1);
        var tt = pk.o.tiers[i];
        var price = plan === 'sub' && tt ? tt.price : oneEach(pk.o, i);
        if (eaPct) { var p = pct(price / pk.size, ref.one); ea.textContent = p > 0 ? 'SAVE ' + p + '%' : 'Base price'; }
        else ea.textContent = money(price / (pk.size * div)) + suffix;
      });
      if (fill) fill.style.width = (t <= 0 ? 0 : (t / (tiers.length - 1)) * 75) + '%';

      if (refPlan) {
        var pk = packFor(ref, tp + 1);
        var pt = pk.o.tiers[tp] || refPlan;
        subTab.textContent = 'SAVE ' + pct(pt.price, pk.o.one) + '%';
        subPrice.textContent = money(pt.price / pk.size) + '/ea';
        if (future) future.textContent = pct(pt.recurring, pk.o.one) + '% OFF';
        if (renew) renew.textContent = 'After your first order: ' + money(pt.recurring / pk.size) + '/ea, ' + C.cadence[tp] + ', until you cancel.';
        if (subLine) subLine.textContent = 'Ships ' + C.cadence[tp];
      }
      if (subStrike) subStrike.textContent = money(ref.one || 0);
      if (onePrice) onePrice.textContent = money(ref.one ? oneEach(ref, tierIndex(oneUnits())) : 0) + '/ea';

      var gift = giftEligible();
      buy.dataset.plan = plan;
      buy.dataset.gift = gift ? 'yes' : 'no';
      if (kitNote) kitNote.textContent = gift ? C.copy.kitOn : C.copy.kitOff;
      if (ctaNote) ctaNote.textContent = plan === 'sub' ? (gift ? C.copy.ctaGift : C.copy.ctaNoGift) : '';
      if (subOpt) subOpt.setAttribute('aria-checked', String(plan === 'sub'));
      if (oneOpt) oneOpt.setAttribute('aria-checked', String(plan === 'one'));

      rows.forEach(function (r) {
        var q = qty(r);
        r.classList.toggle('has-qty', q > 0);
        r.classList.toggle('is-selected', q > 0);
        r.querySelector('output').textContent = q;
        var row = R(r.dataset.row);
        r.classList.toggle('one-only', plan === 'sub' && !canSub(row));
      });

      if (busy) { syncStick(); return; }
      var ls = lines();
      if (n === 0 || !ls.length) {
        cta.disabled = true;
        cta.innerHTML = 'Select at least 1 ' + C.unit;
      } else {
        var was = 0, now = 0;
        ls.forEach(function (l) { was += l.quantity * l.was; now += l.quantity * l.price; });
        cta.disabled = false;
        cta.innerHTML = 'Add to Cart <span class="cta-pill">' + (now < was ? '<s>' + money(was) + '</s> ' : '') + money(now) + '</span>';
      }
      syncStick();
    }

    /* ---- Javvy layout extras (all optional: missing markup = feature off) ---- */
    var stick = buy.querySelector('[data-stick]');
    var stickBtn = stick && stick.querySelector('[data-stick-cta]');
    function syncStick() {
      if (!stickBtn) return;
      stickBtn.innerHTML = !cta.disabled ? cta.innerHTML : rows.length > 1 ? 'Select Your Flavor' : 'Add to Cart';
    }
    if (stick && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        stick.hidden = e.isIntersecting; // phones: visible from page load until the main button is on screen
      }).observe(cta);
      stickBtn.addEventListener('click', function () {
        var add1 = rows.length === 1 && rows[0].querySelector('[data-add1]');
        if (cta.disabled && add1) add1.click(); // single product: add 1, then add to cart
        if (cta.disabled) {
          var grid = buy.querySelector('.jfl') || cta;
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else cta.click();
      });
    }

    /* "as low as $X ~~$Y~~ SAVE UP TO N%" from the real plans */
    (function asLow() {
      var el = buy.querySelector('[data-aslow]');
      var ref = R(C.ref);
      if (!el || !ref || !C.hasSub) return;
      var best = null;
      for (var i = 0; i < 4; i++) {
        var pk = packFor(ref, i + 1);
        var t = pk.o.tiers && pk.o.tiers[i];
        if (!t) continue;
        var each = t.price / pk.size;
        if (best === null || each < best) best = each;
      }
      var was = Math.max(ref.one || 0, ref.compare || 0);
      if (best === null || !(best < was)) return;
      el.querySelector('[data-aslow-now]').textContent = money(best / div) + suffix;
      el.querySelector('[data-aslow-was]').textContent = money(was / div) + suffix;
      el.querySelector('[data-aslow-pct]').textContent = 'SAVE UP TO ' + pct(best, was) + '%';
      el.hidden = false;
    })();

    /* flavor info dialog */
    var modal = buy.querySelector('[data-info-modal]');
    if (modal && typeof modal.showModal === 'function') {
      buy.querySelectorAll('[data-info]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-row]');
          var img = card.querySelector('img');
          var tpl = card.querySelector('template[data-info-body]');
          modal.querySelector('[data-info-title]').textContent = card.querySelector('.jf-name').textContent;
          modal.querySelector('[data-info-media]').innerHTML = img ? '<img src="' + img.currentSrc + '" alt="">' : '';
          modal.querySelector('[data-info-media]').style.background = card.querySelector('.jf-media').style.background;
          modal.querySelector('[data-info-text]').innerHTML = tpl ? tpl.innerHTML : '';
          modal.showModal();
        });
      });
      modal.querySelector('[data-info-close]').addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    rows.forEach(function (r) {
      r.dataset.qty = 0;
      r.querySelector('[data-add1]').addEventListener('click', function () { r.dataset.qty = 1; render(); });
      r.querySelector('[data-inc]').addEventListener('click', function () { r.dataset.qty = qty(r) + 1; render(); });
      r.querySelector('[data-dec]').addEventListener('click', function () { r.dataset.qty = Math.max(0, qty(r) - 1); render(); });
    });
    if (subOpt) subOpt.addEventListener('click', function () { if (C.hasSub) { plan = 'sub'; render(); } });
    if (oneOpt) oneOpt.addEventListener('click', function () { plan = 'one'; render(); });
    buy.querySelectorAll('[data-switch-sub]').forEach(function (b) {
      b.addEventListener('click', function () { if (!C.hasSub) return; plan = 'sub'; render(); if (subOpt) subOpt.focus(); });
    });

    /* Capture phase + stopImmediatePropagation so the theme's own ATC handler never double-fires. */
    cta.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy || !total()) return;
      var items = lineItems();
      if (!items.length) return;
      busy = true;
      cta.disabled = true;
      cta.textContent = 'Adding…';
      if (status) status.textContent = '';
      try {
        await addItems(items);
        rows.forEach(function (r) { r.dataset.qty = 0; });
        await openCartDrawer();
      } catch (err) {
        if (status) status.textContent = err.message;
      } finally {
        busy = false;
        render();
      }
    }, true);

    buy.cebjv = { render: render, lineItems: lineItems, lines: lines, setPlan: function (p) { plan = p; render(); } };
    render();
  }

  /* ---------- Home quick add (real variant + plan) ---------- */
  function initQuickAdd() {
    var btns = [].filter.call(document.querySelectorAll('.qadd[data-variant]'), function (b) { return !b.closest('.jx-vchip'); });
    if (!btns.length) return;
    var live = document.createElement('p');
    live.className = 'sr-only'; live.setAttribute('role', 'status');
    document.body.appendChild(live);
    btns.forEach(function (b) {
      b.addEventListener('click', async function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (b.dataset.added) return;
        var item = { id: Number(b.dataset.variant), quantity: 1 };
        if (b.dataset.plan) item.selling_plan = Number(b.dataset.plan);
        var label = b.textContent;
        b.dataset.added = '1';
        try {
          await addItems([item]);
          live.textContent = b.dataset.name + ' added to cart.';
          b.textContent = 'ADDED ✓';
          await openCartDrawer();
        } catch (err) {
          live.textContent = err.message;
        }
        setTimeout(function () { b.textContent = label; delete b.dataset.added; }, 1600);
      }, true);
    });
  }

  /* ---------- Pick Your Pour cards: add without opening the drawer ----------
     ADD turns into a - qty + stepper bound to that variant + plan's real cart line; the header bag bumps instead. */
  function bumpCart(cart) {
    refreshCount(cart);
    document.querySelectorAll('.cart-btn').forEach(function (c) {
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  }
  async function getCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function changeLine(key, quantity) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var r = await fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    var body = await r.json().catch(function () { return {}; });
    if (!r.ok) throw new Error(body.description || body.message || 'Could not update cart');
    return body;
  }
  function initChipSteppers() {
    var chips = [].map.call(document.querySelectorAll('.jx-vchip .qadd[data-variant]'), function (b) {
      var chip = b.closest('.jx-vchip');
      var name = b.dataset.name;
      var st = document.createElement('span');
      st.className = 'qstep'; st.hidden = true;
      st.innerHTML = '<button type="button" data-qdec aria-label="Remove one ' + name + '">−</button>' +
        '<output aria-live="polite">0</output><button type="button" data-qinc aria-label="Add one more ' + name + '">+</button>';
      b.after(st);
      var sub = chip.querySelector('span small');
      return { b: b, st: st, out: st.querySelector('output'), sub: sub, subText: sub ? sub.textContent : '',
               variant: Number(b.dataset.variant), plan: b.dataset.plan ? Number(b.dataset.plan) : null, qty: 0, key: null };
    });
    if (!chips.length) return;
    var live = document.createElement('p');
    live.className = 'sr-only'; live.setAttribute('role', 'status');
    document.body.appendChild(live);
    var busy = false;

    function sync(cart) {
      chips.forEach(function (c) {
        var lines = (cart.items || []).filter(function (it) {
          var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null;
          return it.variant_id === c.variant && sp === c.plan;
        });
        c.qty = lines.reduce(function (n, it) { return n + it.quantity; }, 0);
        c.key = lines.length ? lines[0].key : null;
        c.keyQty = lines.length ? lines[0].quantity : 0;
        c.b.hidden = c.qty > 0;
        c.st.hidden = c.qty === 0;
        c.out.textContent = c.qty;
        if (c.sub) c.sub.textContent = c.qty > 0 ? c.qty + ' in cart ✓' : c.subText;
        c.b.closest('.jx-vcard').classList.toggle('is-in-cart', c.qty > 0);
      });
    }
    async function run(c, fn, msg) {
      if (busy) return;
      busy = true;
      c.st.classList.add('is-busy'); c.b.disabled = true;
      try {
        var cart = await fn();
        if (!cart || !cart.items) cart = await getCart();
        sync(cart); bumpCart(cart);
        live.textContent = msg();
      } catch (err) {
        live.textContent = err.message;
      } finally {
        busy = false;
        c.st.classList.remove('is-busy'); c.b.disabled = false;
      }
    }
    chips.forEach(function (c) {
      var item = function () { var it = { id: c.variant, quantity: 1 }; if (c.plan) it.selling_plan = c.plan; return it; };
      var said = function () { return c.qty + ' ' + c.b.dataset.name + ' in cart.'; };
      c.b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        run(c, function () { return addItems([item()]).then(function () { return null; }); }, said);
      }, true);
      c.st.querySelector('[data-qinc]').addEventListener('click', function () {
        run(c, function () { return c.key ? changeLine(c.key, c.keyQty + 1) : addItems([item()]).then(function () { return null; }); }, said);
      });
      c.st.querySelector('[data-qdec]').addEventListener('click', function () {
        if (!c.key) return;
        run(c, function () { return changeLine(c.key, Math.max(0, c.keyQty - 1)); }, said);
      });
    });
    getCart().then(sync).catch(function () {});
    window.addEventListener('pageshow', function () { getCart().then(sync).catch(function () {}); });
  }

  /* Build Your Ritual: "GET MY RITUAL" adds the whole bundle (real variants + plans, the price shown) and opens the drawer. */
  function initRitual() {
    document.querySelectorAll('#ritual-out a.btn, a[data-bundle-add]').forEach(function (a) {
      a.addEventListener('click', async function (e) {
        var items;
        try { items = JSON.parse(a.dataset.add || a.dataset.bundleAdd || 'null'); } catch (err) { items = null; }
        if (!items || !items.length) return; // plain link fallback
        e.preventDefault(); e.stopImmediatePropagation();
        if (a.dataset.busy) return;
        a.dataset.busy = '1';
        var label = a.textContent;
        a.textContent = 'ADDING…';
        try {
          await addItems(items);
          a.textContent = 'ADDED ✓';
          await openCartDrawer();
        } catch (err) {
          window.location.assign(a.href);
        } finally {
          setTimeout(function () { a.textContent = label; delete a.dataset.busy; }, 1600);
        }
      }, true);
    });
  }

  /* Below-the-fold Javvy sections: CTAs jump back to the buy box; flavor videos play in place, one at a time. */
  function initJx() {
    document.querySelectorAll('[data-jx-buy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var box = document.querySelector('.jb');
        if (!box) return;
        e.preventDefault();
        var top = box.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
    // flavor videos: play muted on hover (mouse) or when scrolled into view (touch); the button/click toggles sound
    var vids = Array.prototype.slice.call(document.querySelectorAll('[data-jx-video]'));
    var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function stop(v) { v.pause(); v.closest('.jx-vcard').classList.remove('is-playing'); }
    function play(v, sound) {
      vids.forEach(function (o) { if (o !== v) stop(o); });
      v.muted = !sound;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
      v.closest('.jx-vcard').classList.add('is-playing');
    }
    vids.forEach(function (v) {
      var card = v.closest('.jx-vcard'), btn = card.querySelector('.jx-play');
      function toggle() { if (!v.paused && !v.muted) stop(v); else play(v, true); }
      btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      if (hover) {
        card.addEventListener('mouseenter', function () { if (v.paused) play(v, false); });
        card.addEventListener('mouseleave', function () { stop(v); });
      }
    });
    if (!hover && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { if (e.target.paused) play(e.target, false); } else if (!e.target.paused) stop(e.target); });
      }, { threshold: 0.75 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  function initCartButton() {
    document.querySelectorAll('[data-cebjv-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!window.Drawer || !document.querySelector('.cart-drawer')) return; // plain link to /cart
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  /* Gallery: swipe/scroll-snap track, arrows and thumbnails stay in sync. */
  function initGallery(g) {
    var track = g.querySelector('[data-jg-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(g.querySelectorAll('[data-jg-go]'));
    var idx = 0;
    var go = function (i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    var mark = function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === idx && thumbs[i] && thumbs[i].classList.contains('is-on')) return;
      idx = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var th = thumbs[i];
      if (th && th.parentElement.scrollWidth > th.parentElement.clientWidth) {
        th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
      }
      var v = slides[0].querySelector('video');
      if (v) { if (i === 0) { v.play && v.play().catch(function () {}); } else if (v.pause) v.pause(); }
    };
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.dataset.jgGo)); }); });
    var p = g.querySelector('[data-jg-prev]'), n = g.querySelector('[data-jg-next]');
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (n) n.addEventListener('click', function () { go(idx + 1); });
    mark();
  }

  function init() {
    document.querySelectorAll('[data-jg]').forEach(initGallery);
    initCartButton();
    document.querySelectorAll('.buy[data-config]').forEach(initBuy);
    initQuickAdd();
    initChipSteppers();
    initRitual();
    initJx();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
